module.exports = __webpack_public_path__ + "static/media/BurgerFries.eea1cc27.jpg";